import date from './date';
import dateTime from './dateTime';
import time from './time';

export default {
  date,
  dateTime,
  time,
};
